<script>
	// Stores 
	import { 
		mailLocacao
	 } from '../store.js';    
	
	// Componentes
	import { Router, Link, link , Route } from "svelte-routing";

	import PageHeader	from "../components/PageHeader.svelte";
	import Forms from "../components/Forms.svelte";

   	// Code	
	let titlePage = 'Procedimento para desocupação';

	let fields = [
		{
			title: 'O(a) senhor(a) leu a vistoria inicial? *',
			name: 'leuvistoria',
			type: 'select',
			selectValues: [
				{
					title: 'Não',
					value: 'Não'
				},
				{
					title: 'Sim',
					value: 'Sim'
				}
			]
		},
		{
			title: 'A pintura foi feita conforme a vistoria inicial? *',
			obs: 'Obs.: Ter muita atenção na contratação do profissional que irá fazer os serviços, como qualidade da pintura e demais reparos.',
			name: 'pinturavistoria',
			type: 'select',
			selectValues: [
				{
					title: 'Não',
					value: 'Não'
				},
				{
					title: 'Sim',
					value: 'Sim'
				}
			]
		},
		{
			title: 'A pintura tem qualidade? *',
			name: 'pinturaqualidade',
			obs: 'Pergunto isto porque já tivemos casos em que o pintor deu somente uma demão de tinta e a pintura ficou com problema.',
			type: 'select',
			selectValues: [
				{
					title: 'Não',
					value: 'Não'
				},
				{
					title: 'Sim',
					value: 'Sim'
				}
			]
		},
		{
			title: 'Os trincos, fechaduras, vidros, hidra, torneiras, estão exatamente como mencionados na vistoria? *',
			name: 'pinturaqualidade',
			type: 'select',
			selectValues: [
				{
					title: 'Não',
					value: 'Não'
				},
				{
					title: 'Sim',
					value: 'Sim'
				}
			]
		},
		{
			title: 'No imóvel não existe mais nada, como objetos e móveis pessoais? *',
			name: 'pinturaqualidade',
			type: 'select',
			selectValues: [
				{
					title: 'Não',
					value: 'Não'
				},
				{
					title: 'Sim',
					value: 'Sim'
				}
			]
		},
		{
			title: 'Foi feita faxina geral, incluindo ralos? *',
			name: 'pinturaqualidade',
			type: 'select',
			selectValues: [
				{
					title: 'Não',
					value: 'Não'
				},
				{
					title: 'Sim',
					value: 'Sim'
				}
			]
		},
		{
			title:      'Seu nome *',
			name:       'nome',
			required:   'required'
		},
		{
			title:      'Telefone *',
			name:       'telefone',
			required:   'required',
			classe:     'mask-telefone'
		},
		{
			title:      'Email *',
			name:       'email',
			required:   'required',
			type:       'email'
		},
		{
			title:      'CPF *',
			name:       'cpf',
			required:   'required',
			classe:		'mask-cpf',
		},
		{
			title:      'Endereço do Imóvel *',
			name:       'endereco',
			required:   'required'
		},
		{
			title:     'Observações *',
			name:      'mensagem',
			required:  'required',
			type:      'textarea',
			rows: 4,
		}

	];
	
	let loading = false;
	function send() {
		loading = true;
	}
</script>

<PageHeader title={titlePage} buttons=""></PageHeader>

<div class="container">
	<div class="grid grid-size--1 grid-size-sm--1">
		<div class="info">
			<p>Como norma da empresa em todas as desocupações e para maiores esclarecimentos, siga as orientações abaixo:</p>
			<p><b>1)</b> O(a) senhor(a) deverá providenciar a conta final da CEEE, após vistoria final.</p>
			<p><b>2)</b> No dia marcado para vistoria, caso o vistoriador de por aceito o imóvel, já iremos mandar com o vistoriador o DOC dos dias de aluguel até este dia.</p>
			<p><b>3)</b> Lembramos que caso haja necessidade de uma segunda ou mais vistoria, por o imóvel não estar nas condições, <b>lhe será cobrado o percentual de 20% sobre o salário mínimo nacional a cada vistoria</b>, além do Sr.(a) ainda ter que arcar com os dias de aluguel e encargos durante este período, motivo que lhe pedimos especial atenção ao responder o formulário abaixo. </p>
			<p><b>4)</b> Responda e envie o formulário abaixo. Em caso de dúvidas, entre em contato conosco.</p>
		</div>
		<div class="desocupacao">
			<hr>
			<div class="offset-md-3 col-md-6 pl-0 pr-0 pt-20">
				<div class="flex-1 background-gray round-all pa-30 pt-10 pb-20">
					<Forms fields={fields} destiny={$mailLocacao} subjectTitle="{titlePage}" htmlbody={false} />
				</div>
			</div>
		</div>
	</div>
</div>